import { AddIcon, CalendarIcon, ViewIcon } from '@chakra-ui/icons';
import { Box, Button, Center, HStack, Table, Tbody, Td, Th, Thead, Tr, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWarehouses } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import TitleHeader from '../../components/TitleHeader';
import { useTableColors } from '../../Utils';

const Warehouses = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const coolors = useTableColors()
    const navigate = useNavigate()
    useEffect(() => {
        // Fetch warehouses when the component mounts
        fetchWarehousesData();
    }, []);

    const fetchWarehousesData = async () => {
        try {
            const result = await fetchWarehouses();
            if (result.success) {
                setWarehouses(result.data);
            } else {
                setError(result.error);
            }
        } catch (err) {
            console.error('Error fetching warehouses:', err);
            setError('An error occurred while fetching warehouses.');
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <Center mt="20">
                <Loading />
            </Center>
        );
    }

    if (error) {
        return (
            <AccessDenied msg={error} />
        );
    }

    return (
        <Box maxW="full" mx="auto">
            <VStack spacing={6} align="stretch">

                <TitleHeader
                    title="Inventory Management"
                    buttonText={"View"}
                    onClick={() => { }}
                />

                <Table variant="simple" size="sm">
                    <Thead bg={coolors.theadBg}>
                        <Tr>
                            <Th>#</Th>
                            <Th>Name</Th>
                            <Th>Location</Th>
                            <Th>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {warehouses.map((warehouse, index) => (
                            <Tr
                                key={warehouse._id}
                                bg={index % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                                color={coolors.textColor}
                                _hover={{ bg: coolors.rowHoverBg, color: 'white' }}
                                borderBottom="1px solid"
                                borderColor={coolors.borderColor}
                            >
                                <Td>{index + 1}</Td>
                                <Td fontWeight="bold">{warehouse.name}</Td>
                                <Td>{`${warehouse.address.city}, ${warehouse.address.state}`}</Td>
                                <Td>
                                    <HStack spacing={3}>
                                        <Button
                                            size="xs"
                                            colorScheme="blue"
                                            onClick={() => navigate(`/inventory/levels/${warehouse._id}`)}
                                        >
                                            <ViewIcon mr={2} /> Inventory
                                        </Button>
                                        <Button
                                            size="xs"
                                            colorScheme="green"
                                            onClick={() => navigate(`/inventory/receive/${warehouse._id}`)}
                                        >
                                            <AddIcon mr={2} /> Receive
                                        </Button>
                                        <Button
                                            size="xs"
                                            colorScheme="purple"
                                            onClick={() => navigate(`/inventory/transactions/${warehouse._id}`)}
                                        >
                                            <CalendarIcon mr={2} /> Transactions
                                        </Button>
                                    </HStack>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

            </VStack>
        </Box>
    );
};

export default Warehouses;
